import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface DropdownButtonProps {
  createExpense?: boolean;
  className?: string;
}

const DropdownButton = ({createExpense,  className}: DropdownButtonProps) => {
  const [dropdown, setDropdown] = useState(false);
  return (
    <div className="relative hidden md:block">
      <button
        className="bg-[#044E97] text-[#FFFFFF] text-[16px] mt-[-170em] ml-[18em] flex w-11 h-11 rounded-full justify-center items-center py-[12.5px] leading-4 first-letter font-semibold"
        onClick={() => setDropdown((prev) => !prev)}
      >
        {!dropdown ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6 inline-block items-center "
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6 inline-block"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
        )}
      </button>
      {
        createExpense ?
         <>
         {dropdown && (
        <div className="shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] w-[240px] bg-[#ffff] pt-[15px] shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] absolute  ml-[11em]">
          <h3 className="">
            <Link to={'/expenses/create'} className="text-[#000] px-[16px] hover:text-blue-500">
              New Expense
            </Link>
          </h3>
          <h3 className="text-[#000] py-[12px] px-[16px] ">
            <Link to={''} className="hover:text-blue-500">
              Import
            </Link>
          </h3>
        </div>
      )}
         </>
         : 
         <>
          {dropdown && (
        <div className="shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] w-[240px] success bg-[#ffff] pt-[15px] shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] absolute bottom-[50px] ml-[11em] mt-[11em] ">
          <h3 className="">
            <Link to={'/invoices/create'} className="text-[#000] px-[16px] hover:text-blue-500">
              New Invoice
            </Link>
          </h3>
          <h3 className="text-[#000] py-[12px] px-[16px] ">
            <Link to={''} className="hover:text-blue-500">
              Import
            </Link>
          </h3>
        </div>
      )}
         </>
      }
      
    </div>
  );
};

export default DropdownButton;
